import { Box, Divider, Loader, Stack, Text } from '@mantine/core';

import { Declaration } from '@e-origin/shared';

import { useGroupAmendments } from '@hooks/declaration/retrieve/useGroupAmendments';
import { AmendmentSectionView } from './AmendmentSectionView';

interface GroupAmendmentModalProps {
  declaration: Declaration;
}

export const GroupAmendmentModal: React.FC<GroupAmendmentModalProps> = ({ declaration }) => {
  const { data: versionGroups, isLoading } = useGroupAmendments(declaration.messageInfo.LRN);

  if (isLoading) return <Loader />;

  return (
    <Stack>
      {versionGroups?.map(({ version, header, items }, versionIdx) => (
        <Box key={version}>
          {versionIdx > 0 && <Divider my="md" />}
          <Text fw={700} size="xl" mb="sm">
            Version {version}
          </Text>
          {(header.additionalInformation.length > 0 || header.changes.length > 0) && <AmendmentSectionView label="Header" bucket={header} />}
          {items.map((item, itemIdx) => (
            <Box key={item.sequence}>
              {itemIdx > 0 && <Divider my="md" />}
              <AmendmentSectionView label={`Item ${item.sequence}`} bucket={item} />
            </Box>
          ))}
        </Box>
      ))}
    </Stack>
  );
};
